import React, { useMemo } from 'react';

import { Select } from '@duxton-web/ui';
import { colorContentSubtle } from '@duxton-web/design-tokens/themes/light';
import { useSelector } from 'react-redux';

import MultiSelectDropdown from 'omega-rtc/components/form/ucd/common/MultiSelectDropdown';

interface Country {
  countryID: string;
  name: string;
}

interface RootState {
  countries: {
    entities: Country[];
  };
}

interface CountrySelectorProps {
  multiple?: boolean;
  initialValue?: string | string[];
  onChange: (value: string | string[]) => void;
  [key: string]: any; // For spread props
}

const CountrySelector: React.FC<CountrySelectorProps> = ({ multiple, initialValue, onChange, ...props }) => {
  const countries = useSelector((state: RootState) => state.countries.entities);

  const countryOptions = useMemo(() => {
    return (countries || []).map((country: Country) => ({
      value: country.countryID,
      label: country.name,
    }));
  }, [countries]);

  if (multiple) {
    return (
      <MultiSelectDropdown
        placeholder="Country"
        initialValue={Array.isArray(initialValue) ? initialValue : (initialValue ? [initialValue] : [])}
        options={countryOptions}
        width={'132px'}
        height={'36px'}
        onChange={onChange}
        placeholderStyle={{
          color: colorContentSubtle,
        }}
        {...props}
      />
    );
  }

  return (
    <Select
      placeholder="Select Country"
      options={countryOptions}
      onChange={onChange}
      {...props}
    />
  );
};

export default CountrySelector;
